import { ValidationService } from '../../services/validation/validation-service';

class ValidateForms {
    constructor() {
        this.ValidationService = new ValidationService();
        this.ValidationService.bootstrap();

        document.addEventListener('DOMContentLoaded', () => {
            this.preventMultiSubmit();
        });
    }

    preventMultiSubmit() {
        const forms = Array.from(document.querySelectorAll('form.js-no-multisubmit'));

        forms.forEach((form) => {
            // Disable the submit button when to form is submitted successfully
            // prevents duplicate form submissions!
            form.addEventListener('submit', () => {
                const formUID = this.ValidationService.getElementUID(form);
                const validate = this.ValidationService.getFormValidationTask(formUID);
                
                validate.then((success) => {
                    const submitBtn = form.querySelector('[type="submit"]');
                    if (success) {
                        submitBtn.disabled = true;
                    } else {
                        submitBtn.disabled = false;
                    }
                }).catch((error) => {
                    console.log(error);
                });
            });
        });
    }
}

export default new ValidateForms();



// WEBPACK FOOTER //
// ./src/js/modules/forms/validate.js